var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveStreaming = function SvgLiveStreaming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0473 9.09846C8.58064 8.83179 8 9.16875 8 9.70623V15.2938C8 15.8313 8.58064 16.1682 9.0473 15.9015L13.9364 13.1078C14.4067 12.839 14.4067 12.161 13.9364 11.8922L9.0473 9.09846ZM20 4.5H12.42L15.71 1.21L15 0.5L11 4.5H10.97L6.97 0.5L6.28 1.21L9.56 4.5H2C0.9 4.5 0 5.4 0 6.5V18.5C0 19.6 0.9 20.5 2 20.5H20C21.1 20.5 22 19.6 22 18.5V6.5C22 5.4 21.1 4.5 20 4.5ZM20.2 18.7H1.8V6.3H20.2V18.7Z",
    fill: "currentColor"
  })));
};
export default SvgLiveStreaming;